export default __webpack_public_path__ + "static/media/52.eae95549.png";